import { createApp } from 'vue'
import App from './App.vue'
import { getRouter } from './router'
import { configureSimaSuiteComponents } from 'sima-suite-components-vue3'
import { getSettings } from './configuration'
import { analytics, auth, msw, sentry, store } from './plugins'
import translations from './translations'
import { defaultLocale } from './plugins/translations'
import companiesData from '@/plugins/companySelection/companies.json'
import { companyDictionaryKey } from '@/plugins/companySelection/types'
import { navigationGuard } from './router/navigationGuard'
import { getUseMSEntraParameter, syncQueryParameters } from './utils/queryParamsManager'

syncQueryParameters()
await msw.init()
const useMSEntra = getUseMSEntraParameter()
const settings = await getSettings(useMSEntra)
await auth.init(settings.authentication, useMSEntra)
await navigationGuard.init(useMSEntra)

const app = createApp(App)
app.provide(companyDictionaryKey, companiesData)

const router = getRouter()
configureSimaSuiteComponents(app, {}, defaultLocale, translations)
app.use(router)
app.use(store, settings)
app.use(analytics, settings)
app.use(sentry, { router, settings })

app.mount('#app')
